'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.propTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SelectField = require('material-ui/SelectField');

var _SelectField2 = _interopRequireDefault(_SelectField);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

var _WMRequiredLabel = require('../WMRequiredLabel');

var _WMRequiredLabel2 = _interopRequireDefault(_WMRequiredLabel);

var _WMStatefulToolTip = require('../WMStatefulToolTip');

var _WMStatefulToolTip2 = _interopRequireDefault(_WMStatefulToolTip);

var _WMFontIcon = require('../WMFontIcon');

var _WMFontIcon2 = _interopRequireDefault(_WMFontIcon);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * README: When updating this component to match the Material UI component,
 * make sure to check if WMSelectDay, WMSelectMonth, and WMSelectYear are
 * affected as well.
 */

var propTypes = exports.propTypes = {
	autoWidth: _propTypes2.default.bool,
	children: _propTypes2.default.node,
	disabled: _propTypes2.default.bool,
	errorText: _propTypes2.default.node,
	fullWidth: _propTypes2.default.bool,
	floatingLabelFixed: _propTypes2.default.bool,
	floatingLabelText: _propTypes2.default.node,
	hintText: _propTypes2.default.node,
	id: _propTypes2.default.string,
	name: _propTypes2.default.string,
	onChange: _propTypes2.default.func.isRequired,
	onValidate: _propTypes2.default.func,
	required: _propTypes2.default.bool,
	valid: _propTypes2.default.bool,
	errorStyle: _propTypes2.default.object,
	floatingLabelStyle: _propTypes2.default.object,
	hintStyle: _propTypes2.default.object,
	iconStyle: _propTypes2.default.object,
	labelStyle: _propTypes2.default.object,
	listStyle: _propTypes2.default.object,
	menuItemStyle: _propTypes2.default.object,
	menuStyle: _propTypes2.default.object,
	selectedMenuItemStyle: _propTypes2.default.object,
	selectionRenderer: _propTypes2.default.func,
	toolTip: _propTypes2.default.string,
	toolTipIconName: _propTypes2.default.string,
	toolTipIconStyle: _propTypes2.default.object,
	underlineDisabledStyle: _propTypes2.default.object,
	underlineFocusStyle: _propTypes2.default.object,
	underlineStyle: _propTypes2.default.object,
	style: _propTypes2.default.object,
	value: _propTypes2.default.any
};

var WMSelectField = function (_Component) {
	_inherits(WMSelectField, _Component);

	function WMSelectField() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, WMSelectField);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WMSelectField.__proto__ || Object.getPrototypeOf(WMSelectField)).call.apply(_ref, [this].concat(args))), _this), _this.performValidation = function (props) {
			var validationResult = {
				name: props.name,
				isValid: props.required ? props.value && props.valid : props.valid,
				value: props.value
			};

			if (props.onValidate) {
				props.onValidate(validationResult);
			}

			if (_this.context.onValidate) {
				_this.context.onValidate(validationResult);
			}
		}, _this.renderLabel = function (_ref2) {
			var floatingLabelText = _ref2.floatingLabelText,
			    required = _ref2.required,
			    valid = _ref2.valid;
			return _react2.default.createElement(_WMRequiredLabel2.default, {
				label: floatingLabelText,
				required: required,
				valid: valid
			});
		}, _this.renderToolTip = function (_ref3, requireSpacer) {
			var toolTip = _ref3.toolTip,
			    toolTipIconName = _ref3.toolTipIconName,
			    toolTipIconStyle = _ref3.toolTipIconStyle;

			var adjacentStyle = requireSpacer ? _styles2.default.adjacentToolTip : null;
			return _react2.default.createElement(
				_WMStatefulToolTip2.default,
				{
					tooltipContent: toolTip
				},
				_react2.default.createElement(
					_WMFontIcon2.default,
					{
						className: 'material-icons',
						style: _extends({}, _styles2.default.toolTip, adjacentStyle, toolTipIconStyle)
					},
					toolTipIconName
				)
			);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(WMSelectField, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.performValidation(this.props);
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.value === this.props.value) {
				return;
			}

			this.performValidation(nextProps);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			var validationResult = {
				name: this.props.name,
				isValid: true,
				value: this.props.value
			};

			if (this.props.onValidate) {
				this.props.onValidate(validationResult);
			}
			if (this.context.onValidate) {
				this.context.onValidate(validationResult);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    floatingLabelText = _props.floatingLabelText,
			    toolTip = _props.toolTip,
			    toolTipIconName = _props.toolTipIconName,
			    toolTipIconStyle = _props.toolTipIconStyle,
			    required = _props.required,
			    valid = _props.valid,
			    children = _props.children,
			    onValidate = _props.onValidate,
			    selectFieldProps = _objectWithoutProperties(_props, ['floatingLabelText', 'toolTip', 'toolTipIconName', 'toolTipIconStyle', 'required', 'valid', 'children', 'onValidate']);

			var label = null;
			if (floatingLabelText && toolTip) {
				label = _react2.default.createElement(
					'div',
					null,
					this.renderLabel(this.props),
					this.renderToolTip(this.props, true)
				);
			} else if (floatingLabelText) {
				label = this.renderLabel(this.props);
			} else if (toolTip) {
				label = this.renderToolTip(this.props);
			}

			return _react2.default.createElement(
				_WMThemeProvider2.default,
				null,
				_react2.default.createElement(
					_SelectField2.default,
					_extends({}, selectFieldProps, {
						floatingLabelText: label
					}),
					children
				)
			);
		}
	}]);

	return WMSelectField;
}(_react.Component);

WMSelectField.defaultProps = {
	toolTipIconName: 'info',
	valid: true
};
WMSelectField.contextTypes = {
	onValidate: _propTypes2.default.func
};

exports.default = WMSelectField;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMSelectField/index.js